module.exports = __webpack_public_path__ + "static/media/7.1d607386.jpg";